<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
    @keyup.enter="login"
  >
    <div
      class="vx-col rounded-lg bg-white px-3 py-4 sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 sm:m-0 m-4"
    >
      <!-- <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container"> -->
      <div class="vx-card__title mb-base">
        <h4 class="mb-2">Selamat Datang</h4>
        <p>Silahkan masukan email dan password kamu untuk login</p>
      </div>

      <div>
        <vs-input
          v-validate="'required|email|min:3'"
          data-vv-validate-on="blur"
          name="email"
          placeholder="Masukan Email"
          icon-no-border
          icon="icon icon-mail"
          icon-pack="feather"
          label="Email"
          v-model="formData.email"
          class="w-full"
        />
        <span class="text-danger text-sm">{{ errors.first("email") }}</span>

        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required'"
          type="password"
          name="password"
          placeholder="Masukan Password"
          icon-no-border
          icon="icon icon-lock"
          icon-pack="feather"
          label="Password"
          v-model="formData.password"
          class="w-full mt-6"
        />
        <span class="text-danger text-sm">{{ errors.first("password") }}</span>

        <div class="flex flex-wrap justify-end my-5">
          <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                      >Remember Me</vs-checkbox
                    > -->
          <!-- <router-link to="/pages/forgot-password"
            >Forgot Password?</router-link
          > -->
        </div>
        <div class="flex flex-wrap justify-end mb-3">
          <vs-button :disabled="!validateForm" @click="login" ref="buttonLogin"
            >Login</vs-button
          >
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
        </div>
      </vx-card>
    </div>
  </div> -->
</template>

<script>
export default {
  data() {
    return {
      formData: {
        email: "",
        password: "",
      },
      checkbox_remember_me: false,
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() && this.formData.email !== "" && this.formData.password !== ""
      );
    },
  },
  methods: {
    login() {
      this.$vs.loading({
        color: "primary",
      });
      this.$store
        .dispatch("auth/login", this.formData)
        .then((v) => {
          this.$vs.loading.close();
          if (v.data.level.name === "User") {
            this.$vs.notify({
              position: "top-right",
              title: "Akun Tidak Memiliki Akses!",
              text: "Hanya Sahabat ZX yang bisa masuk ke halaman dashboard",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else if (v.data.level.name === "Sahabat ZX" && v.data.status !== 1) {
            this.$vs.notify({
              position: "top-right",
              title: "Akun Kamu Belum Terverifikasi!",
              text: "Hubungin Admin untuk mem-verifikasi akun kamu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            this.$store.commit("auth/SAVE_PROFILE_ACCESS", {
              menu: v.access,
              profile: v.data,
            });
            localStorage.setItem(
              "profileAccess",
              JSON.stringify({
                tokens: v.tokens,
                menu: v.access,
                profile: v.data,
              })
            );
            this.$vs.notify({
              position: "top-right",
              title: `Selamat Datang ${v.data.name}`,
              iconPack: "feather",
              icon: "icon-smile",
              color: "primary",
            });
            this.$router.replace({ path: "/" }).catch(() => {});
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.formData.email = "";
          this.formData.password = "";
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    // checkLogin() {
    //   // If user is already logged in notify
    //   if (this.$store.state.auth.isUserLoggedIn()) {
    //     // Close animation if passed as payload
    //     // this.$vs.loading.close()

    //     this.$vs.notify({
    //       title: "Login Attempt",
    //       text: "You are already logged in!",
    //       iconPack: "feather",
    //       icon: "icon-alert-circle",
    //       color: "warning"
    //     });

    //     return false;
    //   }
    //   return true;
    // },
    // loginJWT() {
    //   if (!this.checkLogin()) return;

    //   // Loading
    //   this.$vs.loading();

    //   const payload = {
    //     checkbox_remember_me: this.checkbox_remember_me,
    //     userDetails: {
    //       email: this.email,
    //       password: this.password
    //     }
    //   };

    //   this.$store
    //     .dispatch("auth/loginJWT", payload)
    //     .then(() => {
    //       this.$vs.loading.close();
    //     })
    //     .catch(error => {
    //       this.$vs.loading.close();
    //       this.$vs.notify({
    //         title: "Error",
    //         text: error.message,
    //         iconPack: "feather",
    //         icon: "icon-alert-circle",
    //         color: "danger"
    //       });
    //     });
    // },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
